<ng-template #addRecordDialog let-data let-ref="addRecordDialogRef">
  <nb-card style="width: 500px;">
    <nb-card-header>
      <h4 class="modal-title text-capitalize">Select {{entityName}}</h4>
    </nb-card-header>
    <nb-card-body>
      <div class="row">
        <div class="form-group col">
          <!-- <label class="form-label text-capitalize">{{entityName}}</label> -->
          <input nbInput class="form-control" #autoInput type="text" placeholder="Start typing to search.." [nbPopover]="templateRef" nbPopoverTrigger="noop"
            (input)="onChange()"
            [nbAutocomplete]="auto"/>
          <nb-autocomplete #auto (selectedChange)="onSelectionChange($event)" [isOpen]="isOpen" [handleDisplayFn]="getDisplayName">
            <nb-option *ngFor="let option of filteredOptions$ | async" [value]="option">
              {{ getDisplayName(option) }}
            </nb-option>
          </nb-autocomplete>
          <ng-template #templateRef>
            <span class="py-1 px-2 d-flex"><strong>{{statusIndicator}}</strong></span>
          </ng-template>
        </div>
      </div>
      <div class="row mt-3" *ngIf="includeRelation && false">
        <div class="form-group col">
          <label class="form-label">Relation</label>
          <input nbInput type="text" placeholder="Enter Relation" class="form-control" (input)="setRelation($event)" />
        </div>
      </div>
      <p *ngIf="!isLoading && (candidateRecords?.length || 0) === 0"> No {{entityName?.toLowerCase()}} available to select.</p>
    </nb-card-body>
    <nb-card-footer class="text-right">
      <button nbButton (click)="dismissDialog()" status="danger" outline class="btn btn-outline-danger">Cancel</button>
      <button nbButton (click)="addRecord($event)" status="primary" class="btn btn-primary ml-3">Add {{entityName?.toLowerCase()}}</button>
    </nb-card-footer>
  </nb-card>
</ng-template>

<div *ngIf="!(selectedRecords.length > 0 || isEditable)">{{emptyResultsMsg}}</div>
<nb-tag-list *ngIf="selectedRecords.length > 0 || isEditable" [nbSpinner]="isLoading">
  <nb-tag *ngFor="let selectedRecord of selectedRecords"
          [text]="getDisplayName(selectedRecord.entity || selectedRecord)"
          [removable]="isEditable" appearance="outline" status="info"
          (remove)="removeRecord(selectedRecord.entity || selectedRecord)"
          (click)="popout($event, selectedRecord)">
  </nb-tag>
</nb-tag-list>
<!-- Only show the spawn/add button when editable AND (multiSelect OR no selection yet) -->
<button *ngIf="isEditable && (multiSelect || (selectedRecords?.length || 0) === 0)"
        [nbSpinner]="isLoading"
        nbButton outline shape="round" size="small" status="info"
        (click)="spawnDialog(addRecordDialog)" class="ml-1">
  Add <nb-icon icon="plus-outline"></nb-icon>
</button>